import { __assign, __read } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import MoaStyledComponent from '../../Style/MoaStyled';
import { FloatingBox, Typography } from '../../';
var getScaledMaxWidth = function (scale, coordinates) {
    var maxValue = coordinates.reduce(function (acc, cur) {
        return acc > cur[0] ? acc : cur[0];
    }, 0);
    return maxValue * scale;
};
var getScaledMaxHeight = function (scale, coordinates) {
    var maxValue = coordinates.reduce(function (acc, cur) {
        return acc > cur[1] ? acc : cur[1];
    }, 0);
    return maxValue * scale;
};
var toScaledSVGCoordinates = function (scale, coordinates, maxHeight) {
    return coordinates.map(function (coord) {
        var x = coord[0] * scale;
        var y = coord[1] * scale;
        return [x, maxHeight - y];
    });
};
// label position에 따라 guideBoxProps 옵션 변경
var getLabelPositionRealOptions = function (labelPosition) {
    if (labelPosition === "center")
        return { center: true, };
    if (labelPosition === "leftTop")
        return { horLeft: true, verTop: true, };
    if (labelPosition === "rightTop")
        return { horRight: true, verTop: true, };
    if (labelPosition === "leftBottom")
        return { horLeft: true, verBottom: true, };
    if (labelPosition === "rightBottom")
        return { horRight: true, verBottom: true, };
    if (labelPosition === "top")
        return { horCenter: true, verTop: true, };
    if (labelPosition === "bottom")
        return { horCenter: true, verBottom: true, };
    if (labelPosition === "left")
        return { horLeft: true, verCenter: true, };
    if (labelPosition === "right")
        return { horRight: true, verCenter: true, };
    return { center: true, };
};
var StyledComponent = function (props) {
    var coordinates = props.coordinates, _a = props.scale, scale = _a === void 0 ? 10 : _a, fill = props.fill, fillOpacity = props.fillOpacity, fillRule = props.fillRule, stroke = props.stroke, strokeWidth = props.strokeWidth, strokeLinecap = props.strokeLinecap, strokeLinejoin = props.strokeLinejoin, strokeDasharray = props.strokeDasharray, strokeDashoffset = props.strokeDashoffset, labelColor = props.labelColor, labels = props.labels, labelSpacing = props.labelSpacing, labelPosition = props.labelPosition;
    var _b = __read(useState(''), 2), points = _b[0], setPoints = _b[1];
    var _c = __read(useState(0), 2), scaledMaxWidth = _c[0], setScaledMaxWidth = _c[1];
    var _d = __read(useState(0), 2), scaledMaxHeight = _d[0], setScaledMaxHeight = _d[1];
    useEffect(function () {
        setScaledMaxWidth(getScaledMaxWidth(scale, coordinates));
        setScaledMaxHeight(getScaledMaxHeight(scale, coordinates));
    }, [coordinates, scale]);
    useEffect(function () {
        var coordinatesSVG = toScaledSVGCoordinates(scale, coordinates, scaledMaxHeight);
        setPoints(coordinatesSVG.map(function (coord) { return coord.join(','); }).join(' '));
    }, [scaledMaxHeight, coordinates, scale]);
    return (_jsx("div", { style: { width: 'auto', height: 'auto' }, children: _jsxs("div", { style: { width: 'auto', height: 'auto', position: 'relative' }, children: [_jsx("svg", { width: scaledMaxWidth, height: scaledMaxHeight, children: _jsx("polygon", { points: points, fill: fill, fillOpacity: fillOpacity, fillRule: fillRule, stroke: stroke, strokeWidth: strokeWidth, strokeLinecap: strokeLinecap, strokeLinejoin: strokeLinejoin, strokeDasharray: strokeDasharray, strokeDashoffset: strokeDashoffset }) }), _jsx(FloatingBox, { width: scaledMaxWidth, height: scaledMaxHeight, x: 0, y: 0, guideBoxProps: __assign({ width: 'inherit', height: 'inherit', spacing: labelSpacing }, getLabelPositionRealOptions(labelPosition)), children: labels && labels.map(function (label, index) { return (_jsx(Typography, { color: labelColor || undefined, children: label }, index)); }) })] }) }));
};
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
